import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

// Import testing utility for debugging
import './utils/testApiEndpoints';

// Initialize LogRocket
import { initializeLogRocket } from './utils/logrocketUtils';

initializeLogRocket();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
